import type { ReactNode } from 'react'
import { cn } from '@/lib/utils/cn'

interface TooltipProps {
  label: string
  children: ReactNode
  className?: string
  /** `end` alinha à direita (útil na última coluna de tabelas, evita overflow). */
  align?: 'center' | 'end'
}

/** Tooltip acessível: aparece no hover e também no foco por teclado. */
export function Tooltip({ label, children, className, align = 'center' }: TooltipProps) {
  return (
    <span className={cn('group/tooltip relative inline-flex', className)}>
      {children}
      <span
        role="tooltip"
        className={cn(
          'pointer-events-none absolute bottom-full z-30 mb-1.5 whitespace-nowrap',
          align === 'end' ? 'right-0' : 'left-1/2 -translate-x-1/2',
          'rounded-md bg-slate-900 px-2 py-1 text-xs font-medium text-slate-50 opacity-0 shadow-lg transition-opacity group-hover/tooltip:opacity-100 group-focus-within/tooltip:opacity-100 dark:bg-slate-700',
        )}
      >
        {label}
      </span>
    </span>
  )
}
